import { useCallback, useEffect, useRef, useState } from 'react';
// A result belongs to a selection AND a particular attempt, including retries.
// Rendering hides the old selection synchronously, before effect cleanup runs.
export function useBoundRequest(key, load) {
    const loader = useRef(load);
    loader.current = load;
    const [attempt, setAttempt] = useState(0);
    const [state, setState] = useState({ key: '', attempt: 0, status: 'idle' });
    useEffect(() => {
        if (!key)
            return;
        let active = true;
        const request = loader.current;
        setState({ key, attempt, status: 'loading' });
        Promise.resolve().then(request).then(data => { if (active)
            setState({ key, attempt, status: 'ready', data }); }, () => { if (active)
            setState({ key, attempt, status: 'error' }); });
        return () => { active = false; };
    }, [key, attempt]);
    const current = state.key === key && state.attempt === attempt;
    const reload = useCallback(() => setAttempt(n => n + 1), []);
    return {
        data: current && state.status === 'ready' ? state.data : undefined,
        status: !key ? 'idle' : current ? state.status : 'loading',
        reload
    };
}
